module.exports = __webpack_public_path__ + "static/img/stamp_reject.484517e6.png";